module.exports = __webpack_public_path__ + "static/media/Group 2225.95772b67.svg";